export const MAIN_CATEGORIES = [
  'Golf Clubs',
  'Golf Clothing',
  'Golf Shoes',
  'Golf Balls',
  'Golf Bags',
  'Golf Trolleys',
  'Golf GPS',
  'Golf Accessories',
];
